require('./investmentsResume.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { formatText } = require('core/i18n').i18n;
// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');

const ShowMoreItems = require('components/globalPosition/globalPositionCollapsable/globalPositionShowMoreItems/globalPositionShowMoreItems');

class InvestmentsResume extends React.Component {

    buildTable() {
        const { columnsInfo } = this.props;
        let rows = [];

        columnsInfo.forEach((columnInfo)=>{
            let cells = [];
            columnInfo.forEach((value, indexVal)=>{
                cells.push(
                    <OKTableCell key={indexVal}>
                        {value}
                    </OKTableCell>
                )
            });

            rows.push(
                <OKTableRow key={columnInfo[0]} className="investments-resume__row">
                    {cells}
                </OKTableRow>
            );
        });

        return(
            rows.slice(0,5) // Because the US OPE444-6850 specifies that the table must show only 5 rows
        );
    }

    buildEmptyState() {
        const text = formatText('pGInvestments-stocksAccountsEmptyStateErrorMessage');
        return (
            <EmptyState
                primaryText={text}
            />
        );
    }

    buildLink() {
        const {seeAllLink} = this.props;
        const to = seeAllLink;
        const text = formatText('pGInvestments-stocksAccountsSeeAllLabelButton');

        return (
            <ShowMoreItems
                showMoreLink={to}
                showMoreText={text}
            />
        );
    }

    render() {
        const { columnsInfo } = this.props;
        let content = <LoadingSection />;

        if (columnsInfo && columnsInfo.length) {
            const tableRows = this.buildTable();
            const link = this.buildLink();

            content = (
                <div className="investments-resume-cc">
                    <OKTable>
                        <tbody>
                            {tableRows}
                        </tbody>
                    </OKTable>
                    {link}
                </div>
            );
        } else {
            content = this.buildEmptyState();
        }

        return content;
    }
}

InvestmentsResume.propTypes = {
    columnsInfo: PropTypes.array.isRequired,
    seeAllLink: PropTypes.string.isRequired
}

module.exports = InvestmentsResume;
